// Utils
import { isWebBridgeSupported } from '@shopee/web-bridge-sdk';

// Types
import type { AddOrChangePhoneExitHandling } from '@shopee-user/business-customization-types';

export function addOrChangePhoneExitHandling({
  nonce,
  isWebViewLogoutAfterCredentialChangeEnabled,
  webViewLogoutSuccessfully,
  webViewNotifyRefreshTokenAfterChangeCredentials,
  exitWithSuccess,
  safelyRedirectToNextUrlFromQueryString,
}: AddOrChangePhoneExitHandling) {
  if (isWebBridgeSupported()) {
    if (isWebViewLogoutAfterCredentialChangeEnabled) {
      webViewLogoutSuccessfully();
    } else {
      webViewNotifyRefreshTokenAfterChangeCredentials({ nonce });
      exitWithSuccess();
    }
  } else {
    safelyRedirectToNextUrlFromQueryString({ code: nonce });
  }
}
